import { render } from "./ViewSessionActivitiesDialog.vue?vue&type=template&id=60bca6ec&scoped=true"
import script from "./ViewSessionActivitiesDialog.vue?vue&type=script&lang=js"
export * from "./ViewSessionActivitiesDialog.vue?vue&type=script&lang=js"

import "./ViewSessionActivitiesDialog.vue?vue&type=style&index=0&id=60bca6ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bca6ec"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QCardActions,QSpace});qInstall(script, 'directives', {ClosePopup});
